<template>
	<Layout class="p-5 bg-white">
		<Form :label-width="80">
			<FormItem class="w-50" label="设备型号">
				<Select v-model="device.deviceType" clearable placeholder="设备型号" class="w-100">
					<Option v-for="item in deviceType" :value="item.deviceTypeNum">{{ item.deviceType }}</Option>
				</Select>
			</FormItem>
			<FormItem class="w-50" label="设备编号">
				<Input v-model="device.deviceNumber" placeholder="请输入设备编号"></Input>
			</FormItem>
			<FormItem class="w-50" label="上传时间间隔">
				<Input v-model="device.timeInterval" placeholder="请输入上传时间间隔"></Input>
			</FormItem>
			<FormItem class="w-50" label="报警值">
				<Input v-model="device.alarmValue" placeholder="请输入报警值"></Input>
			</FormItem>
			<FormItem class="w-50" label="设备名称">
				<Input v-model="device.name" placeholder="请输入设备名称(非必填)"></Input>
			</FormItem>
			<FormItem class="text-right">
				<Button @click="submit" type="primary">提交</Button>
				<Button @click="cancel" class="ml-2">取消</Button>
			</FormItem>
		</Form>
	</Layout>
</template>

<script>
	export default {
		data() {
			return {
				device: {
					id: "",
					name: "",
					deviceNumber: "",
					deviceType: "",
					deviceState: "",
					alarmValue: "",
					timeInterval: "",
					lie: "",
					userId: ""
				},
				deviceType: [],

				roles: []
			}
		},
		created: function() {

		},
		methods: {
			submit: function() {

				if (this.$data.device.deviceType.length === 0) {
					this.message.error("设备型号必须输入");
					return;
				}

				if (this.$data.device.deviceNumber.length === 0) {
					this.message.error("设备编号必须输入");
					return;
				}

				if (this.$data.device.timeInterval.length === 0) {
					this.message.error("上传时间间隔必须输入");
					return;
				}

				if (this.$data.device.alarmValue.length === 0) {
					this.message.error("报警值必须输入");
					return;
				}
				console.log(this.$data.device)
				this.http.post({
					url: "/device/new",
					param: this.$data.device
				}).then(data => {
					this.$Message.success('新增成功');
				});
			},
			searchDeviceType: function() {
				this.http.get({
					url: "/device-type/list",
				}).then(data => {
					this.$data.deviceType = data;
				});
			},
			cancel: function() {
				this.$tabs.close();
			}
		},
		created: function() {
			this.searchDeviceType();
		},

		mounted: function() {
			this.$data.device.userId = this.$route.params.userId;
		}

	}
</script>

<style>
</style>
